module.exports = __webpack_public_path__ + "static/media/emailunhover.2360d0cb.svg";